import { AuthPicture } from '@auth-picture-current';

// Фасад над иллюстрацией темы справа от формы входа (раскладка 'split', см.
// AuthLayout). За алиасом @auth-picture-current → Picture/<theme> компонент, а
// не картинка: разметка у тем разная. Раньше выбор шёл тернаром по isGreenTheme,
// и картинки обеих тем лежали в каждом бандле.
export const Picture = () => <AuthPicture />;
